export default __webpack_public_path__ + "static/media/jarringshot.69bf8763.png";